import { CIcon } from '~/icons/types'

export const ciBoatOpen: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.907 8.842a.514.514 0 0 0-.446-.2l-10.7.9v-.013a10.585 10.585 0 0 0-2.492-3.395.5.5 0 0 0-.838.414l.3 3.249-4.986.419a.488.488 0 0 0-.263.116 1.19 1.19 0 0 0-1.072-.73H1.663A1.733 1.733 0 0 0 .002 11.39v1.143a1.24 1.24 0 0 0 1.2 1.274h.247v.6h-.226a.5.5 0 0 0 0 1h.222v.329a.25.25 0 0 1-.222.274.488.488 0 0 0-.487.5.51.51 0 0 0 .51.5 1.24 1.24 0 0 0 1.2-1.274v-1.93h.267l.04 2.08a.5.5 0 0 0 .5.492h13.549a5.393 5.393 0 0 0 4.07-1.927 21.575 21.575 0 0 0 3.09-5.124.5.5 0 0 0-.055-.486ZM10.56 7.887a7.08 7.08 0 0 1 1.159 1.74l-.988.084-.171-1.824Zm-9.558 4.647V11.39a.736.736 0 0 1 .662-.791h1.75c.1 0 .2.128.2.275v.808l-.7 1.143a.508.508 0 0 0-.088-.018H1.202c-.1 0-.2-.112-.2-.274ZM20.118 13.8a4.4 4.4 0 0 1-3.312 1.579H3.743l-.032-1.583 4.773-.12a.5.5 0 0 0-.013-1h-.013l-4.351.109.977-1.6 17.61-1.481c-.132.274-.3.61-.5.98-.012 0-.025 0-.036.01-2.864 1.428-5.98 1.785-9.775 1.88a.5.5 0 1 0 .013 1h.013a26.375 26.375 0 0 0 8.925-1.427c-.368.578-.774 1.13-1.216 1.653Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-open',
  type: 'thin'
}
